import React from "react";
import { Input } from "../../ui/Input";
import { SelectCountry } from "../../selectors/country/selectCountry";
import { Textarea } from "../../ui/Textarea";
export const PublicSectorForm = React.memo(({formData, onChange, isReadOnly, isReport}) => {
    return (
        <>
            <Input
                label={"Full Name of Government/Local Authority"}
                value={formData.uboGovernmentLocalName}
                name={"uboGovernmentLocalName"}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
                required
            />

            <SelectCountry
                label={"Country of Government or Local Authority"}
                name={"uboCountry"}
                value={formData.uboCountry}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
                required
            />

            <Textarea 
                label={"Government or Authority Description"}
                value={formData.uboDescription}
                name={"uboDescription"}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"Name of Contact/Representative"}
                value={formData.uboContactName}
                name={"uboContactName"}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />

        </>
    );
})